import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Signable} from '../../../signing-pages/signing-sidebar/activity-logs/activity-logs-dto';
import {DashboardFacade} from '../store/dashboard.facade';

@Component({
  selector: 'app-unreadchatmessagewidget',
  templateUrl: './unreadchatmessagewidget.component.html',
  styleUrls: ['./unreadchatmessagewidget.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class UnreadchatmessagewidgetComponent implements OnInit {

  public fetchUnreadChatMessages = this.dashboardFacade$.unreadChatMessages$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchUnreadChatMessages()
  }

  openDocument(messageData: Signable){
    if (messageData && messageData?.recipient_role_detail) {
        const { id } = messageData;
        const { unique_id } = messageData.recipient_role_detail;
        const url = `/#/sender/${id}/${unique_id}`;
        window.open(url, '_blank');
      }
  }
}
